import { CharacterStateBase, RifleShoot } from './_stateLibrary';
import { ICharacterState } from '../../interfaces/ICharacterState';
import { Character } from '../Character';
import * as THREE from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { Impact } from '../../enums/impact';
import * as TWEEN from '@tweenjs/tween.js';
import { Npc } from '../Npc';
import { CharacterAnimation } from '../../enums/CharacterAnimation';
import { RifleIdle } from "./RifleIdle";
import { RifleWalk } from "./RifleWalk";

export class RifleAim extends CharacterStateBase implements ICharacterState {
    public rayCaster: THREE.Raycaster;
    private intersectedObject: any;
    private dummySphereImpact: any;
    private shootingCount = 0;
    public tween: TWEEN.Tween<any>;

    constructor(character: Character) {
        super(character);

        this.rayCaster = new THREE.Raycaster();

        this.character.simulation.velocitySimulator.damping = 0.6;
        this.character.simulation.velocitySimulator.mass = 10;
        this.character.isAiming = true;
        this.character.simulation.setArcadeVelocityTarget(0);
        this.playAnimation(CharacterAnimation.RifleAim, 0.1, true, true);
        this.character.world.uiManagerService.setTargetVisibility(true);
        this.spawnObjectOnPoint();
    }

    public update(timeStep: number): void {
        super.update(timeStep);
        this.fallInAir();
        this.onDie();
        if (this.character.actions.shoot.isPressed) {
            this.shootingCount += 1;
            if (this.shootingCount === 1) {
                //this.spawnImpactOnTarget(this.intersectedObject);
            }
        }


        if (this.character.actions.up.isPressed) {
            this.character.setState(new RifleWalk(this.character));
        }
        if (this.character.actions.down.isPressed) {
            this.character.setState(new RifleWalk(this.character));
        }
        if (this.character.actions.left.isPressed) {
            this.character.setState(new RifleWalk(this.character));
        }
        if (this.character.actions.right.isPressed) {
            this.character.setState(new RifleWalk(this.character));
        }
        if (this.character.cameraOperator) {
            const array = this.character.world.graphicsWorld.children.filter((children) => children.name !== 'cameraHelper');
            this.rayCaster.setFromCamera(new THREE.Vector2(0, 0), this.character.cameraOperator.camera);
            const intersects = this.rayCaster.intersectObjects(array, true);
            for (let i = 0; i < intersects.length; i++) {
                if (intersects[i].object.type !== 'LineSegments' && this.dummySphereImpact) {
                    this.intersectedObject = intersects[0];
                }
            }
        }
        TWEEN.update();
    }

    public onInputChange(): void {
        super.onInputChange();

        if (this.character.actions.aim.justReleased) {
            this.character.world.uiManagerService.setTargetVisibility(false);
            this.character.setState(new RifleIdle(this.character));
        }

        if (this.character.actions.shoot.isPressed) {
            this.character.setState(new RifleShoot(this.character));
        }

        if (this.character.actions.aim.justReleased) {
            this.character.setState(new RifleIdle(this.character));
        }
    }

    private makeObjectInvisible(): void {
        this.intersectedObject.object.visible = false;
    }

    private spawnObjectOnPoint() {
        const loader = new GLTFLoader();
        loader.load('../../assets/impact_spawn.glb', (gltf) => {
            gltf.scene.name = Impact.Bullet;
            gltf.scene.scale.set(0.05, 0.05, 0.05);
            this.dummySphereImpact = gltf.scene;
            this.character.world.graphicsWorld.add(gltf.scene);

        }, undefined, (error) => {
            console.error(error);
        });
    }

    spawnImpactOnTarget(intersectedTarget): void {
        if (intersectedTarget.object.parent instanceof Npc) {
            intersectedTarget.object.attach(this.dummySphereImpact);
            /* We convert the intersection point from world to local pos */
            const impactLocalPos = intersectedTarget.object.worldToLocal(intersectedTarget.point);
            /* So we can then apply the dummy sphere position locally inside intersected object */
            this.dummySphereImpact.position.set(impactLocalPos.x, impactLocalPos.y, impactLocalPos.z);

            intersectedTarget.object.parent.isGettingShot = true;

            const characterNpc = intersectedTarget.object.parent as Npc;
            characterNpc.takeDamage(50);
        }
    }
}
